module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAABCUlEQVQokY3TzSpGQRzA4YdEWJNEJJKUla2EkI9CWdi7BhfgvQJrKxsLRZSUJElJuQJJ8pVsfSRLTf3fOuk95zWrqfN7mjPTTE2pVIJhrGMFnwpGbXzawCyO0PwfsIwbjARqqgbeMIFbjOIwD9Vm5q+B7jCOAzQWgTReMIZ7TGIfDUUgix4wHai+CKTxFOgRM9grozwgVkh7ecY8dhIqAmIvqzFfxFY10IXNmP9gt64g7sQZunEc1+Y9D3RE3IMTLMUKFTfdHnEvTrNxJdAWcR/OsYDvbJAFrRH34wJzf+MsaIl4AJd5cRmkOP3rIK7iXXzlHV0C2xjCdVyDj7y4DNbinKfSORfF8AtmDDg7IpWDogAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.png
// module id = ZK0V
// module chunks = 1